import { z } from "zod";

import { optionalEmailSchema } from "@/lib/validation";

const optionalString = z.string().trim().optional();

export const createAggregatorSchema = (invalidEmailMessage: string) =>
  z.object({
    name: optionalString,
    other_info: optionalString,
    contact_email: optionalEmailSchema({ invalid: invalidEmailMessage }),
    phone: optionalString,
    legal_address: optionalString,
    physical_address: optionalString,
    district: optionalString,
    legal_status: optionalString,
    year_of_establishment: optionalString,
    tier: optionalString,
    wings_vendor_id: optionalString,
    org_type: optionalString,
    membership_fee: optionalString,
    language: optionalString,
    membership_fee_needed: z.boolean(),
  });

export const createAdministratorSchema = (invalidEmailMessage: string) =>
  z.object({
    uuid: optionalString,
    first_name: optionalString,
    middle_name: optionalString,
    last_name: optionalString,
    email: optionalEmailSchema({ invalid: invalidEmailMessage }),
    contact_phone: optionalString,
    location: optionalString,
    identification_card_number: optionalString,
    gender: optionalString,
    day_of_birth: z.date().nullable(),
    position: optionalString,
  });

export type AggregatorFormValues = z.infer<ReturnType<typeof createAggregatorSchema>>;
export type AdministratorFormValues = z.infer<ReturnType<typeof createAdministratorSchema>>;

// rows carry a client-side id so the table can edit/remove an entry before it is saved
export type AdministratorRow = AdministratorFormValues & { id: string };

export const EMPTY_AGGREGATOR_VALUES: AggregatorFormValues = {
  name: "",
  other_info: "",
  contact_email: "",
  phone: "",
  legal_address: "",
  physical_address: "",
  district: "",
  legal_status: "",
  year_of_establishment: "",
  tier: "",
  wings_vendor_id: "",
  org_type: "",
  membership_fee: "",
  language: "",
  membership_fee_needed: false,
};

export const EMPTY_ADMINISTRATOR_VALUES: AdministratorFormValues = {
  uuid: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  email: "",
  contact_phone: "",
  location: "",
  identification_card_number: "",
  gender: "",
  day_of_birth: null,
  position: "",
};
